<script setup>
import { onBeforeUnmount, onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import apiClient from "@/axios";

// Proje bileşenleri
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";

const store = useStore();
const router = useRouter();

// Giriş bilgileri ve hata mesajı için ref'ler
const username = ref("");
const password = ref("");
const errorMessage = ref("");

// Sayfa yüklendiğinde ve ayrıldığında Vuex state'ini yönet
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
});

onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
});

const login = async () => {
  errorMessage.value = ''; // Her denemede eski hatayı temizle
  try {
    const response = await apiClient.post('/auth/signin', {
      username: username.value,
      password: password.value
    });
    const token = response.data.accessToken;
    localStorage.setItem('jwtToken', token);
    await router.push({ name: 'Dashboard' });
  } catch (error) {
    errorMessage.value = 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.';
    console.error("Login error:", error);
  }
};
</script>

<template>
  <!-- Flexbox ile ortalanmış tam ekran ana konteyner -->
  <main class="fullscreen-login">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-4 col-lg-5 col-md-7 mx-auto">
          <div class="card z-index-0">
            <div class="card-header text-center pt-4">
              <p class="text-secondary">Sözleşme Yönetim Paneli</p>
            </div>
            <div class="card-body">
              <!-- Hata mesajı alanı -->
              <div v-if="errorMessage" class="alert alert-danger text-white text-center p-2 mb-3" role="alert">
                {{ errorMessage }}
              </div>

              <form role="form" @submit.prevent="login">
                <div class="mb-3">
                  <argon-input
                      id="username"
                      type="text"
                      placeholder="Kullanıcı Adı"
                      aria-label="Kullanıcı Adı"
                      v-model="username"
                      size="lg"
                  />
                </div>
                <div class="mb-3">
                  <argon-input
                      id="password"
                      type="password"
                      placeholder="Şifre"
                      aria-label="Şifre"
                      v-model="password"
                      size="lg"
                  />
                </div>
                <!--
                <argon-switch id="rememberMe" name="remember-me">
                  Beni Hatırla
                </argon-switch>
                -->
                <div class="text-center">
                  <argon-button
                      class="mt-4"
                      variant="gradient"
                      color="success"
                      fullWidth
                      size="lg"
                      type="submit"
                  >
                    Giriş Yap
                  </argon-button>
                </div>

                <!--
                <p class="text-sm mt-3 mb-0 text-center">
                  Hesabınız yok mu?
                  <a href="javascript:;" class="text-success font-weight-bold">
                    Kayıt Olun
                  </a>
                </p>
                -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<style>
/*
  Tam ekran, kaydırmasız ve ortalanmış bir yapı için stiller.
  'scoped' olmadan eklendi çünkü sayfanın tamamını etkilemesi gerekiyor.
*/
.fullscreen-login {
  width: 100%;
  height: 100vh; /* Ekran yüksekliği kadar ol, taşma yok */
  display: flex;
  align-items: center; /* Dikeyde ortala */
  justify-content: center; /* Yatayda ortala */

  /* Arka plan resmini ve konumunu ayarla */
  background-image: url('https://images.unsplash.com/photo-1556761175-5973dc0f32e7?q=80&w=2832&auto=format&fit=crop');
  background-size: cover;
  background-position: center;
  position: relative; /* ::before pseudo-element'i için gerekli */
}

/* Okunabilirliği artırmak için resmin üzerine koyu bir katman ekliyoruz. */
.fullscreen-login::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Siyah, %50 şeffaflıkta */
}

/* Formun ve diğer içeriklerin karartma katmanının üzerinde kalmasını sağlar. */
.fullscreen-login .container {
  position: relative;
  z-index: 1;
}
</style>
